import React, { useState } from "react";
import "../../../../styles/lead-mangement/lead-journey.css";
import LeadOverview from "./LeadOverview";
import LeadTimeline from "../../lead-revamp-v2/LeadTimeline";
import LeadCycle from "../../lead-revamp-v2/lead-cycle/LeadCycle";
// import LeadFollowup from "./LeadFollowup";
import LMSFollowupV2 from "./LMSFollowupV2";
import LeadFollowupNewUI from "./LeadFollowupNewUI";

const tabList = [
  "overview",
  "timeline",
  "lifecycle",
  "Follow-ups",
  "quick actions",
];

const LeadJourney = ({ userInfoData, rowData }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [expanded, setExpanded] = useState({});

  const isLeadClosedOrConverted =
    rowData?.lead_status === "closed" || rowData?.lead_status === "converted";

  const filteredTabList = isLeadClosedOrConverted
    ? tabList.filter((tab) => tab !== "quick actions")
    : tabList;

  const toggleExpand = (idx) => {
    setExpanded((prev) => ({ ...prev, [idx]: !prev[idx] }));
  };

  return (
    <>
      <div className="lms-v2-tabs-container mt15">
        {filteredTabList.map((tab, idx) => (
          <div
            key={tab}
            className={`lms-v2-tab${
              activeTab === idx ? " lms-v2-tab-active" : ""
            }`}
            onClick={() => setActiveTab(idx)}
            style={{ cursor: "pointer" }}
          >
            {tab}
          </div>
        ))}
      </div>

      {activeTab === 0 && <LeadOverview rowData={rowData} />}

      {activeTab === 1 && (
        <LeadTimeline
          userInfoData={userInfoData}
          rowData={rowData}
          toggleExpand={toggleExpand}
          expandedItems={expanded}
        />
      )}

      {activeTab === 2 && (
        <LeadCycle userInfoData={userInfoData} rowData={rowData} />
      )}

      {activeTab === 3 && (
        <LMSFollowupV2
          userInfoData={userInfoData}
          rowData={rowData}
          setActiveTab={setActiveTab}
        />
      )}

      {activeTab === 4 && (
        <>
          {/* <LeadFollowup userInfoData={userInfoData} rowData={rowData} /> */}
          <LeadFollowupNewUI userInfoData={userInfoData} rowData={rowData} />
        </>
      )}
    </>
  );
};

export default LeadJourney;
